<template>
  <header v-if="userStore.isLoggedIn">
    <div class="page-header--mobile">
      <div class="page-header--mobile-left">
        <!-- TODO: Breadcrumbs -->
        <slot name="pageBreadcrumbs"></slot>
      </div>

      <div class="page-header--mobile-right">
        <Tooltip position="left">
          <template v-slot:text>
            <Button @click="launchTour" severity="" outlined class="p-button-borderless">
              <IconHelp />
            </Button>
          </template>
          <template v-slot:tooltip> Launch self-guided tour </template>
        </Tooltip>

        <IconNotifications />
        <IconSettings
          class="header-icon"
          @click="router.push({ name: 'settings' })"
          v-if="userStore.isStaff"
        />

        <UserMenu position="bottom">
          <template #button>
            <div class="user-avatar">
              {{ userStore.getInitials() }}
            </div>
          </template>
        </UserMenu>
      </div>
    </div>

    <div class="header-left">
      <h1>
        <slot name="pageTitle"></slot>
      </h1>
      <slot name="pageDescription"></slot>
    </div>
    <div class="header-right">
      <div class="header-user-menu">
        <Tooltip position="left">
          <template v-slot:text>
            <Button @click="launchTour" severity="" outlined class="p-button-borderless">
              <IconHelp />
            </Button>
          </template>
          <template v-slot:tooltip> Launch self-guided tour </template>
        </Tooltip>

        <IconNotifications />
        <IconSettings
          class="header-icon"
          @click="router.push({ name: 'settings' })"
          v-if="userStore.isStaff"
        />

        <UserMenu position="bottom">
          <template #button>
            <div class="user-avatar">
              {{ userStore.getInitials() }}
            </div>
          </template>
        </UserMenu>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { Button } from 'primevue';

import Tooltip from '@/components/global/Tooltip.vue';
import UserMenu from '@/components/global/UserMenu.vue';

import IconHelp from '@/icons/header/IconHelp.svg?component';
import IconNotifications from '@/icons/header/IconNotifications.svg?component';
import IconSettings from '@/icons/header/IconSettings.svg?component';

import { useUserStore } from '@/stores/user';
const userStore = useUserStore();

const router = useRouter();

const launchTour = () => {
  if (userStore.userData) {
    router.push({ name: 'overview', hash: '#tour' });
  }
};
</script>

<style lang="scss">
header {
  @include mixins.flex-center($horiz: space-between, $wrap: true);
  margin-bottom: variables.$vantage-base-sizing-lg;
}

.header-right {
  @include mixins.flex-center($horiz: flex-end);
}

.header-user-menu {
  @include mixins.flex-center($horiz: flex-end);
  column-gap: variables.$vantage-base-sizing-xs;
  flex-basis: 100%;
}

.mobile .header-user-menu {
  display: none;
}

.page-header--mobile {
  display: none;
}

.mobile .page-header--mobile {
  @include mixins.flex-center($horiz: space-between);
  flex-basis: 100%;
  width: 100%;

  .page-header--mobile-right {
    @include mixins.flex-center($horiz: flex-end);
    column-gap: variables.$vantage-base-sizing-xs;
  }

  .page-header--mobile-left {
    @include mixins.flex-center($horiz: flex-start);
    @include typography.font-body($weight: medium, $size: sm);
    column-gap: variables.$vantage-base-sizing-xxxs;
    color: variables.$vantage-base-primitives-color-tertiary-400;

    circle {
      display: none;
    }

    a {
      @include mixins.flex-center($horiz: flex-start);
      color: variables.$vantage-base-primitives-color-tertiary-400;
      margin-left: -4px;
    }

    span {
      color: variables.$vantage-base-primitives-color-primary-500;
    }
  }
}

.user-avatar {
  @include mixins.flex-center();
  background: variables.$vantage-base-primitives-color-secondary-500;
  border-radius: 50%;
  color: variables.$vantage-base-primitives-color-background-100;
  cursor: pointer;
  height: variables.$vantage-base-sizing-xl;
  width: variables.$vantage-base-sizing-xl;
}

.header-icon {
  cursor: pointer;
}
</style>
